<template>
  <div class="page-container">
    <main :class="['main-content', { nested: isMemberCenterContext }]">
      <div class="page-inner-box">

        <div class="my-exams-container">
          <!-- 主内容区 -->
          <div class="content-main">

            
            <!-- 我的考试列表 -->
            <div class="exams-section">
              <div class="section-header">
                <div class="section-title">我的考试</div>
              </div>
              
              <div class="divider"></div>
              
              <!-- 考试列表 -->
              <div v-loading="myExamsLoading" class="exams-list">
                <!-- 考试记录卡片 -->
                <div v-for="exam in exams" :key="exam.id" class="exam-card">
                  <div class="exam-cover">
                    <!-- 这里可以放封面图，暂时用纯色背景 -->
                    <div class="cover-text">
                      <div class="cover-title">{{ exam.title }}</div>
                    </div>
                  </div>
                  
                    <div class="exam-content">
                    <div class="exam-header">
                      <div class="exam-info">
                        <div class="info-row" v-if="exam.examNumber">
                          <span class="label">准考证号：</span>
                          <span class="value exam-number">{{ exam.examNumber }}</span>
                        </div>
                        <div class="info-row">
                          <span class="label">考试时间：</span>
                          <span class="value">{{ exam.startTime }} ~ {{ exam.endTime }}</span>
                        </div>
                        <div class="info-row">
                          <span class="label">答题时长：</span>
                          <span class="value">{{ exam.duration }}分钟</span>
                          <span class="label ml-20">总分：</span>
                          <span class="value">{{ exam.totalScore }}分</span>
                        </div>
                        <div class="info-row" v-if="exam.allowTimes > 0">
                          <span class="label">剩余次数：</span>
                          <span class="value">{{ exam.remainTimes }} / {{ exam.allowTimes }}</span>
                        </div>
                      </div>
                      <div class="exam-status-tag" :class="exam.status">
                        {{ exam.statusText }}
                      </div>
                    </div>
                    
                    <div class="exam-actions">
                      <!-- 逻辑调整：
                           1. 如果是进行中(in_progress) 且 有剩余次数 -> 显示“开始答题”
                           2. 如果是已结束(ended) -> 显示“已结束” (禁用按钮)
                           3. 未开始 -> 显示“未开始”
                           
                           暂时保留查看结果按钮，但需要确认逻辑。
                       -->
                      
                      <template v-if="exam.status === 'in_progress' && exam.remainTimes > 0">
                         <el-button class="action-btn filled" @click="startExam(exam)">开始答题</el-button>
                      </template>
                      <template v-else-if="exam.status === 'not_started'">
                        <el-button class="action-btn outlined" disabled>未开始</el-button>
                      </template>
                      <template v-else>
                         <el-button class="action-btn outlined" disabled>已结束/次数用尽</el-button>
                         <!-- 如果考过，可以提供查看最近一次结果的入口吗？目前接口没给 recordId，暂不支持 -->
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- 分页 -->
              <div v-if="myExamsTotal > myExamsQuery.pageSize" class="pagination">
                <el-pagination
                  layout="prev, pager, next"
                  :total="myExamsTotal"
                  :page-size="myExamsQuery.pageSize"
                  :current-page="myExamsQuery.pageNum"
                  prev-text="<"
                  next-text=">"
                  @current-change="handleCurrentChange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

  </div>
</template>

<script>
import { getMyExamList } from '@/api/examApi'

export default {
  name: 'MyExams',
  computed: {
    isMemberCenterContext() {
      return this.$route.path.startsWith('/member-center')
    }
  },
  created() {
    this.loadMyExams()
  },
  data() {
    return {
      currentPage: 1,
      myExamsLoading: false,
      myExamsTotal: 0,
      myExamsQuery: {
        pageNum: 1,
        pageSize: 10,
        status: undefined
      },
      exams: []
    }
  },
  methods: {
    parseExamDatetime(val) {
      if (val == null || val === '') return null
      if (val instanceof Date) return Number.isNaN(val.getTime()) ? null : val

      if (typeof val === 'number') {
        const n = Number(val)
        if (!Number.isFinite(n)) return null
        const ms = n < 1e12 ? n * 1000 : n
        const d = new Date(ms)
        return Number.isNaN(d.getTime()) ? null : d
      }

      const s = String(val).trim()
      if (!s) return null
      if (/^\d+$/.test(s)) {
        const n = Number(s)
        if (!Number.isFinite(n)) return null
        const ms = n < 1e12 ? n * 1000 : n
        const d = new Date(ms)
        return Number.isNaN(d.getTime()) ? null : d
      }

      const normalized = s.replace(/-/g, '/')
      const d = new Date(normalized)
      return Number.isNaN(d.getTime()) ? null : d
    },
    getStatusNumByTime(startVal, endVal) {
      const start = this.parseExamDatetime(startVal)
      const end = this.parseExamDatetime(endVal)
      if (!start && !end) return null

      const now = Date.now()
      if (start && now < start.getTime()) return 0
      if (end && now > end.getTime()) return 2
      return 1
    },
    normalizeMyExam(exam) {
      // 适配新接口返回的数据结构
      const id = exam.id
      const title = exam.examName || exam.paperName || ''
      const startTime = exam.examStartTime
      const endTime = exam.examEndTime
      const duration = exam.answerDuration
      const totalScore = exam.totalScore
      const passScore = exam.passScore
      // 状态处理：0：未开始，1：进行中，2：已结束
      const statusMap = {
        0: 'not_started',
        1: 'in_progress',
        2: 'ended'
      }
      const statusTextMap = {
        0: '未开始',
        1: '进行中',
        2: '已结束'
      }

      const rawStatusNum = Number(exam.status)
      const statusNumFromTime = this.getStatusNumByTime(startTime, endTime)
      const statusNum = statusNumFromTime != null ? statusNumFromTime : (Number.isFinite(rawStatusNum) ? rawStatusNum : undefined)
      const status = statusMap[statusNum] || 'unknown'
      const statusText = statusTextMap[statusNum] || '未知'
      
      // 判断是否可以参加考试
      // 逻辑：状态为进行中(1) 且 剩余次数 > 0
      const remainTimes = Number(exam.remainTimes)
      const allowTimes = Number(exam.allowTimes)
      const submitLimit = Number(exam.submitLimit)
      const canStart = statusNum === 1 && ((Number.isFinite(remainTimes) ? remainTimes : 0) > 0 || submitLimit === 2)
      
      // 判断是否可以查看结果/再次答题

      
      return {
        id,
        title,
        startTime,
        endTime,
        duration,
        totalScore,
        passScore,
        status,
        statusText,
        canStart,
        remainTimes: Number.isFinite(remainTimes) ? remainTimes : 0,
        allowTimes: Number.isFinite(allowTimes) ? allowTimes : 0,
        examNumber: exam.examNumber || '',
        raw: exam
      }
    },
    async loadMyExams() {
      if (this.myExamsLoading) return
      this.myExamsLoading = true
      try {
        const res = await getMyExamList(this.myExamsQuery)
        const data = res && res.data
        const list = (data && data.list) || []
        const total = (data && data.total) || 0
        
        this.exams = list.map(item => this.normalizeMyExam(item))
        this.myExamsTotal = Number(total) || 0
      } catch (err) {
        this.exams = []
        this.myExamsTotal = 0
        console.error(err)
        this.$message.error((err && err.msg) || '获取我的考试失败')
      } finally {
        this.myExamsLoading = false
      }
    },
    viewExamDetail(examId) {
      // 查看考试详情/结果

      const id = examId
      if (!id) return
      this.$router.push({ path: `/exam-intro/${id}`, query: { mode: 'exam' } })
    },
    retakeExam(examId) {
      // 再次答题
      const id = examId
      if (!id) return
      this.$router.push({ path: `/exam-intro/${id}`, query: { mode: 'exam' } })
    },
    startExam(exam) {
      // 开始答题，跳转到考试介绍页
      const id = exam && typeof exam === 'object' ? exam.id : exam
      if (!id) return
      const q = {}
      q.mode = 'exam'
      if (exam && typeof exam === 'object') {
        if (exam.title) q.title = exam.title
        if (exam.duration != null) q.duration = exam.duration
        if (exam.totalScore != null) q.totalScore = exam.totalScore
        if (exam.passScore != null) q.passScore = exam.passScore
      }
      this.$router.push({ path: `/exam-intro/${id}`, query: q })
    },

    handleCurrentChange(val) {
      // 分页变化处理
      this.currentPage = val
      this.myExamsQuery.pageNum = val
      this.loadMyExams()
    }
  }
}
</script>

<style scoped lang="scss">
.page-container { min-height: 100vh; display: flex; flex-direction: column; }
.main-content { flex: 1; padding-top: 20px; }
.main-content.nested { margin-top: 0; }
.main-content.nested .page-inner-box { width: 100%; margin: 0; }

.my-exams-container {
  display: flex;
  gap: 24px;
}

/* 主内容区样式 */
.content-main {
  flex: 1;
  background-color: #fff;
  min-height: 500px;
}

/* 我的考试 */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #3E2CCD;
}

.divider {
  height: 1px;
  background-color: #eee;
  margin-bottom: 20px;
}

/* 考试列表 */
.exams-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 考试卡片 */
.exam-card {
  display: flex;
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #ebeef5;
  padding: 20px;
  min-height: 160px;
  box-sizing: border-box;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 8px 24px rgba(62, 44, 205, 0.08);
    border-color: #d0d7ff;
    transform: translateY(-2px);
  }
}

.exam-cover {
  width: 180px;
  height: 100%;
  background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%);
  border-radius: 8px;
  margin-right: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.cover-text {
  text-align: center;
}

.cover-title {
  font-size: 15px;
  color: #3E2CCD;
  font-weight: 600;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.exam-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 4px 0;
}

.exam-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.exam-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.info-row {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #606266;
}

.label {
  color: #909399;
  min-width: 70px;
}

.value {
  color: #303133;
  font-weight: 500;
}

.exam-number {
  font-family: 'Courier New', monospace;
  letter-spacing: 1px;
  color: #3E2CCD;
  font-weight: 600;
}

.ml-20 {
  margin-left: 24px;
}

.exam-status-tag {
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  
  &.in_progress {
    background: linear-gradient(135deg, #3E2CCD 0%, #6A5AF9 100%);
    box-shadow: 0 2px 8px rgba(62, 44, 205, 0.3);
  }
  
  &.not_started {
    background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%);
    box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
  }
  
  &.ended {
    background: linear-gradient(135deg, #9ca3af 0%, #b0b8c4 100%);
  }
  
  &.completed {
    background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
  }
  
  &.uncompleted {
    background: linear-gradient(135deg, #ef4444 0%, #f87171 100%);
  }
}

.exam-actions {
  display: flex;
  gap: 12px;
  margin-top: 8px;
}

.action-btn {
  padding: 10px 28px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  
  &.filled {
    background: linear-gradient(135deg, #3E2CCD 0%, #6A5AF9 100%);
    border: none;
    color: #fff;
    box-shadow: 0 4px 12px rgba(62, 44, 205, 0.3);
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(62, 44, 205, 0.4);
    }
  }
  
  &.outlined {
    background-color: #fff;
    border: 1px solid #3E2CCD;
    color: #3E2CCD;
    
    &:hover {
      background-color: #f5f3ff;
      border-color: #6A5AF9;
    }
  }
}

/* 分页 */
.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  padding-bottom: 20px;
}

::v-deep .el-pagination {
  .btn-prev, .btn-next {
    background-color: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 0 10px;
    height: 32px;
    line-height: 32px;
    min-width: 32px;
  }
  
  .el-pager li {
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    margin: 0 5px;
    color: #606266;
    height: 32px;
    line-height: 32px;
    min-width: 32px;
    
    &.active {
      background-color: #3E2CCD;
      border-color: #3E2CCD;
      color: #fff;
    }
  }
}
</style>
